module.exports = __webpack_public_path__ + "img/sage-3.702348de.webp";